import styled, { css } from 'styled-components';

const AddressCheckOfferPlacementStyled = styled.div`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      .offer-placement__container {
        padding: 48px 0px;

        h1 {
          margin: 16px 0 10px;
          font-size: 16px;
          font-weight: 700;
          line-height: 20px;

          ${media.tablet.up} {
            margin: 16px 0 32px;
          }

          ${media.desktop.up} {
            margin: 16px 0 40px;
            font-size: 20px;
            line-height: 28px;
          }
        }
      }

      .address-check-offer-tiles__container {
        display: flex;
        display: grid;
        grid-auto-rows: 1fr;
        gap: 16px;
        position: relative;

        ${media.tablet.up} {
          grid-auto-flow: column;
        }

        ${media.desktop.up} {
          column-gap: 24px;
        }

        // Mobile Swiper styles
        ${media.mobile.down} {
          .swiper {
            width: 340px;
            margin-bottom: 40px;
          }

          .swiper-wrapper {
            display: flex;
            align-items: center;
          }

          .swiper-slide {
            width: 340px;
            display: flex;
            justify-content: center;
          }

          .swiper-navigation {
            position: absolute;
            bottom: 0px;
            left: 0;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            height: 40px;
            padding: 0 24px;
            z-index: 10;
          }

          .swiper-button-next,
          .swiper-button-prev {
            position: relative;
            z-index: 20;
            margin: 0;
            color: inherit;
            top: 0;
            transform: none;
          }

          .swiper-button-next::after,
          .swiper-button-prev::after {
            font-size: 1.3rem;
            font-weight: 900;
          }

          .swiper-button-next {
            right: calc((100% - 100px) / 2);
          }

          .swiper-button-prev {
            left: calc((100% - 100px) / 2);
          }

          .swiper-pagination {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0;
            line-height: 0;
            height: 100%;
            transform: none;
            top: 0;
          }

          .swiper-pagination-bullet {
            background-color: ${colors.primary.white};
            border: 2px solid ${colors.primary.gravity};
            opacity: 1;
            margin: 0 4px;
            vertical-align: middle;
          }

          .swiper-pagination-bullet.swiper-pagination-bullet-active {
            border: none;
            background-color: ${colors.primary.red};
          }
        }
      }

      .address-check-offer-tile {
        background-color: ${colors.primary.neutralLight};
        border-radius: 15px;
        padding: 20px 24px;
        flex: 1;
        width: 310px;

        ${media.tablet.up} {
          width: 230px;
        }

        ${media.desktop.up} {
          width: 354px;
        }

        &__tooltip-icon {
          height: 16px !important;
          width: 16px !important;
          margin-bottom: 0 !important;
        }

        &__icon {
          path {
            fill: ${colors.primary.red};
            color: ${colors.primary.red};
          }
          height: 32px;
          width: 32px;
          margin-bottom: 15px;
        }

        svg {
          height: 32px;
          width: 32px;
          margin-bottom: 15px;

          ${media.tablet.up} {
            height: 100%;
            width: 100%;
          }
        }

        &__heading {
          font-size: 18px;
          font-weight: 700;
          line-height: 22px;
          margin-bottom: 10px;
        }

        &__copy {
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
        }
      }
    `;
  }}
`;

export default AddressCheckOfferPlacementStyled;
